import Scorecard from './scorecard'
import ScorecardQuery from './scorecard.query'

export { ScorecardQuery }

export default Scorecard
